module.exports = __webpack_public_path__ + "img/Port Affairs Handling.ca99eb43.png";